import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const CsatCollected: React.FC = () => {
  return (
    <>
      <Spacer height="4x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Thank you for your feedback!"
          description={{
            text: "Message displayed after upvoting/downvoting the help center articles links",
          }}
        />
      </Typography>
    </>
  );
};
